var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-gallery-list-item"},[_c('v-img',{attrs:{"height":_vm.height,"width":_vm.width,"src":_vm.item.url},on:{"click":function($event){return _vm.handleClickItem(_vm.item)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }